module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-cn-china.c638cfcb.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-cn-china.png
// module id = 2624
// module chunks = 11